<template>
  <div>
    <!-- ─── HISTÓRICO ─── -->
    <h1 class="vi-section-title">Histórico</h1>
    <b-row class="vi-kpi-row">
      <b-col xl="4">
        <div class="vi-kpi-card vi-kpi-card--orange">
          <h3 class="vi-kpi-label">Total Visitas</h3>
          <h2 class="vi-kpi-val vi-kpi-val--white">{{ totalVisitas }}</h2>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="vi-kpi-card vi-kpi-card--dark">
          <h3 class="vi-kpi-label vi-kpi-label--white">Total Faturação</h3>
          <h2 class="vi-kpi-val vi-kpi-val--white">
            {{ formatarEuro(totalVendas) }}
          </h2>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="vi-kpi-card">
          <h3 class="vi-kpi-label">Ticket Médio</h3>
          <h2 class="vi-kpi-val">{{ formatarEuro(ticketMedio) }}</h2>
        </div>
      </b-col>
    </b-row>

    <!-- ─── SEGMENTOS ─── -->
    <b-row class="vi-kpi-row">
      <b-col xl="4">
        <div class="vi-kpi-card">
          <div class="pb-2">
            <h3 class="vi-kpi-label">Clientes Assíduos</h3>
            <span class="vi-kpi-hint">
              Visitou pelo menos {{ definicoes.limiteAssiduoVisitas }} vezes em
              {{ definicoes.limiteAssiduoDias }} dias
            </span>
          </div>
          <h2 class="vi-kpi-val">{{ visitasAssiduo }}</h2>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="vi-kpi-card">
          <div class="pb-2">
            <h3 class="vi-kpi-label">Clientes Frequentes</h3>
            <span class="vi-kpi-hint">
              Visitou pelo menos {{ definicoes.limiteFrequenteVisitas }} vezes
              em {{ definicoes.limiteFrequenteDias }} dias
            </span>
          </div>
          <h2 class="vi-kpi-val">{{ visitasFrequente }}</h2>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="vi-kpi-card">
          <div class="pb-2">
            <h3 class="vi-kpi-label">Clientes Ocasionais</h3>
            <span class="vi-kpi-hint">
              Visitou pelo menos {{ definicoes.limiteOcasionalVisitas }} vezes
              em {{ definicoes.limiteOcasionalDias }} dias
            </span>
          </div>
          <h2 class="vi-kpi-val">{{ visitasOcasional }}</h2>
        </div>
      </b-col>
    </b-row>

    <!-- ─── GRÁFICOS PIZZA ROW 1 ─── -->
    <b-row class="d-flex align-items-stretch mb-3">
      <b-col cols="12" md="6" class="mb-3 d-flex flex-column">
        <div class="vi-chart-card flex-fill">
          <div class="vi-chart-header">
            <h3 class="vi-chart-title">Consumo por restaurante</h3>
            <span class="vi-chart-sub">% de faturação</span>
          </div>
          <div
            v-if="
              pieRestaurantes.chartData.datasets[0] &&
              pieRestaurantes.chartData.datasets[0].data.some((v) => v > 0)
            "
          >
            <doughnut-chart
              id="pie-restaurantes"
              :height="300"
              :chart-data="pieRestaurantes.chartData"
              :extra-options="pieRestaurantes.extraOptions"
            />
          </div>
          <div v-else class="vi-empty">Sem dados a mostrar</div>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-3 d-flex flex-column">
        <div class="vi-chart-card flex-fill">
          <div class="vi-chart-header">
            <h3 class="vi-chart-title">Consumo por período da refeição</h3>
            <span class="vi-chart-sub">% de faturação</span>
          </div>
          <div
            v-if="
              pieRefeicoes.chartData.labels &&
              pieRefeicoes.chartData.labels.length > 0
            "
          >
            <doughnut-chart
              id="pie-refeicoes"
              :height="300"
              :chart-data="pieRefeicoes.chartData"
              :extra-options="pieRefeicoes.extraOptions"
            />
          </div>
          <div v-else class="vi-empty">Sem dados a mostrar</div>
        </div>
      </b-col>
    </b-row>

    <!-- ─── GRÁFICOS PIZZA ROW 2 ─── -->
    <b-row class="d-flex align-items-stretch mb-3">
      <b-col cols="12" md="6" class="mb-3 d-flex flex-column">
        <div class="vi-chart-card flex-fill">
          <div class="vi-chart-header">
            <h3 class="vi-chart-title">Consumo por faixa etária</h3>
            <span class="vi-chart-sub">% de faturação</span>
          </div>
          <div
            v-if="
              pieFaixaEtaria.chartData.datasets[0] &&
              pieFaixaEtaria.chartData.datasets[0].data.some((v) => v > 0)
            "
          >
            <doughnut-chart
              id="pie-faixa-etaria"
              :height="300"
              :chart-data="pieFaixaEtaria.chartData"
              :extra-options="pieFaixaEtaria.extraOptions"
            />
          </div>
          <div v-else class="vi-empty">Sem dados a mostrar</div>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="mb-3 d-flex flex-column">
        <div class="vi-chart-card flex-fill">
          <div class="vi-chart-header">
            <h3 class="vi-chart-title">Consumo por género</h3>
            <span class="vi-chart-sub">% de faturação</span>
          </div>
          <div
            v-if="
              pieGenero.chartData.datasets[0] &&
              pieGenero.chartData.datasets[0].data.some((v) => v > 0)
            "
          >
            <doughnut-chart
              id="pie-genero"
              :height="300"
              :chart-data="pieGenero.chartData"
              :extra-options="pieGenero.extraOptions"
            />
          </div>
          <div v-else class="vi-empty">Sem dados a mostrar</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import DoughnutChart from "@/components/Charts/DoughnutChart";

  export default {
    name: "InsightsKpis",
    components: { DoughnutChart },
    props: {
      totalVisitas: { type: Number, default: 0 },
      totalVendas: { type: Number, default: 0 },
      ticketMedio: { type: Number, default: 0 },
      visitasAssiduo: { type: Number, default: 0 },
      visitasFrequente: { type: Number, default: 0 },
      visitasOcasional: { type: Number, default: 0 },
      definicoes: { type: Object, default: () => ({}) },
      pieRestaurantes: {
        type: Object,
        default: () => ({
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        }),
      },
      pieRefeicoes: {
        type: Object,
        default: () => ({
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        }),
      },
      pieFaixaEtaria: {
        type: Object,
        default: () => ({
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        }),
      },
      pieGenero: {
        type: Object,
        default: () => ({
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        }),
      },
    },
    methods: {
      formatarEuro(valor) {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valor || 0);
      },
    },
  };
</script>

<style scoped>
  .vi-section-title {
    font-size: 18px;
    font-weight: 800;
    color: #1a1210;
    letter-spacing: -0.3px;
    margin: 0 0 14px;
  }
  .vi-kpi-row {
    margin-bottom: 8px;
  }
  .vi-kpi-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 20px 22px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.15s;
  }
  .vi-kpi-card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }
  .vi-kpi-card--orange {
    background: #ff825d;
    border-color: #ff825d;
  }
  .vi-kpi-card--dark {
    background: #1a1210;
    border-color: #1a1210;
  }
  .vi-kpi-label {
    font-size: 12px !important;
    font-weight: 700 !important;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 6px !important;
  }
  .vi-kpi-label--white {
    color: rgba(255, 255, 255, 0.6);
  }
  .vi-kpi-val {
    font-size: 36px !important;
    font-weight: 800 !important;
    color: #1a1210 !important;
    letter-spacing: -1.5px;
    line-height: 1.1;
    margin: 0 !important;
  }
  .vi-kpi-val--white {
    color: #fff !important;
  }
  .vi-kpi-hint {
    font-size: 12px;
    color: #b0a8a0;
    display: block;
    margin-top: 2px;
  }

  /* Charts */
  .vi-chart-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }
  .vi-chart-header {
    padding: 16px 20px;
    border-bottom: 1px solid #f5f2ef;
  }
  .vi-chart-title {
    font-size: 14px;
    font-weight: 700;
    color: #1a1210;
    margin: 0 0 2px;
  }
  .vi-chart-sub {
    font-size: 12px;
    color: #b0a8a0;
  }
  .vi-empty {
    text-align: center;
    padding: 48px 20px;
    color: #b0a8a0;
    font-size: 13.5px;
    font-style: italic;
  }
</style>
